var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NovedadesComponent } from './components/novedades/novedades.component';
import { PreferenciaComponent } from './components/preferencia/preferencia.component';
import { SearchResultComponent } from './components/search/search-result.component';
// nuevos
import { DespachoDiarioComponent } from './components/despacho-diario/despacho-diario.component';
import { UsuarioComponent } from './components/usuario/usuario.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { FavoritosComponent } from './components/favoritos/favoritos.component';
import { CedulaComponent } from './components/cedula/cedula.component';
import { ExpedienteListComponent } from './components/expediente/expediente-list.component';
import { NuevaCausaComponent } from './components/ingresocausa/nueva-causa.component';
import { IngresoMasivoComponent } from './components/ingresomasivo/ingreso-masivo.component';
import { TasasNoExpComponent } from './components/tasa/tasa-noexp.component';
import { UsuarioNoAutorizadoComponent } from './components/usuario-no-autorizado/usuario-no-autorizado.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { UuidViewComponent } from './components/uuid/uuid-view.component';
import { EnlaceNoAutorizadoComponent } from './components/enlace-no-autorizado/enlace-no-autorizado.component';
import { UuidParteViewComponent } from './components/uuid-parte/uuid-parte-view.component';
import { UuidParteDeshabilitadoComponent } from './components/uuid-parte/uuid-parte-deshabilitado.component';
var appRoutes = [
    { path: 'novedades', component: NovedadesComponent },
    { path: 'novedades/tasaOk/:idTasa', component: NovedadesComponent },
    { path: 'novedades/tasaError/:idTasa', component: NovedadesComponent },
    { path: 'search', component: SearchResultComponent },
    { path: 'preferencia', component: PreferenciaComponent },
    { path: 'expediente', component: ExpedienteListComponent },
    { path: 'despacho', component: DespachoDiarioComponent },
    { path: 'usuario', component: UsuarioComponent },
    { path: 'perfil', component: PerfilComponent },
    { path: 'favoritos', component: FavoritosComponent },
    { path: 'cedula', component: CedulaComponent },
    { path: 'nuevacausa', component: NuevaCausaComponent },
    { path: 'ingresomasivo', component: IngresoMasivoComponent },
    { path: 'tasasnoexp', component: TasasNoExpComponent },
    { path: 'agenda', component: AgendaComponent },
    { path: 'usuario-no-autorizado', component: UsuarioNoAutorizadoComponent },
    //lectura de qr de actuacion
    { path: 'actuacion/:uuidCod', component: UuidViewComponent },
    { path: 'enlace-no-autorizado', component: EnlaceNoAutorizadoComponent },
    //lectura QR de vinculacion
    { path: 'vinculacion-rep/:uuidParCod', component: UuidParteViewComponent },
    { path: 'desvinculacion-rep', component: UuidParteDeshabilitadoComponent },
    // inicio
    { path: '', redirectTo: 'novedades', pathMatch: 'full' },
    //match all
    { path: '**', redirectTo: '', pathMatch: 'full' }
];
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
AppRoutingModule = __decorate([
    NgModule({
        imports: [
            RouterModule.forRoot(appRoutes)
        ],
        exports: [
            RouterModule
        ]
    })
], AppRoutingModule);
export { AppRoutingModule };
//# sourceMappingURL=app.routing.js.map